export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#={}[\]]{2,256}([-.]{1}[a-z0-9]+)*\.[a-zA-Z]{2,6}(:[0-9]{1,5})?(\/\S*)?$/;
export const PARTIAL_URL_REGEX =
  /https?:\/\/[-a-zA-Z0-9@:%._+~#={}[\]]{2,256}\.[a-zA-Z]{2,6}(:[0-9]{1,5})?(\/[^<\s]*?)?(?=\s|$)/g;
export const PARTIAL_TRACKED_LINK_REGEX = /https:\/\/\{[a-zA-Z0-9_]+\}(?=\s|$)/g;
export const ATTRIBUTES_REGEX = /\{([a-zA-Z0-9_]+)\}/g;
